{% block sw_cms_element_acris_blog_image_preview %}
    <div class="sw-cms-el-preview-acris-blog-image">
        <img
            :src="assetFilter('/acrisblog/administration/static/img/cms/acris_preview_landscape_small.jpg')"
            alt=""
        >
    </div>
{% endblock %}
